import { render, staticRenderFns } from "./TerminalPromo.vue?vue&type=template&id=0e8db9d1&scoped=true"
import script from "./TerminalPromo.vue?vue&type=script&lang=ts"
export * from "./TerminalPromo.vue?vue&type=script&lang=ts"
import style0 from "./TerminalPromo.vue?vue&type=style&index=0&id=0e8db9d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8db9d1",
  null
  
)

export default component.exports